import { Pipe, PipeTransform } from '@angular/core';
import * as pluralize from 'pluralize';

@Pipe({
  name: 'pluralize',
  standalone: false
})
export class PluralizePipe implements PipeTransform {
  /**
   * Transforms a given sentence to its plural form unless the `skip` flag is set to true.
   *
   * @param sentence - The input string to be pluralized.
   * @param skip - If true, the sentence will not be pluralized and will be returned as is.
   * @returns The pluralized sentence if `skip` is false; otherwise, returns the original sentence. Returns `undefined` if no sentence is provided.
   */
  transform(sentence?: string, skip?: boolean): string | undefined {
    return sentence && !skip ? pluralize(sentence) : sentence;
  }
}
